import React from "react";
import styles from "./index.module.css";

const Loader = () => <span className={styles.loader} />;

export default Loader;
